// import axios from 'axios'
// const ConstList = {

import axios from "axios";

// DOMAIN: 'm-and-t.jp.auth0.com',
// AUTH_DOMAIN: 'https://m-and-t.jp.auth0.com',
// //ユーザー登録に使用する
// CLIENT_ID: 'AhAZrgvr70S0tVGIhq7xVxLvaN7JzZRV',
// // DATABASE_NAME: 'Username-Password-Authentication',
// DATABASE_NAME: 'keiri-syowa',
// //M2M認証に使用する
// API_CLIENT_ID: 'CYIoJtYhK6n5sYhpGAuaOAOEdX5DSBpW',

// AUDIENCE: 'https://m-and-t.jp.auth0.com/api/v2/',

// //シークレットトークンを使用したアクセストークン取得用URL
// TOKEN_URL: `https://m-and-t.jp.auth0.com/oauth/token`,
// PG_API_DOMAIN: 'https://keiri-system.local',
// PG_API_URL: 'https://keiri-system.local/api/pg_api.php',
// LOCAL_PG_API_URL: 'http://localhost/kosuApi/pg_api.php',

// API: 'https://system.syowa.com/api/',
// SERVER_API: 'https://keiri-system.local/api/',
// LOCAL_API: 'http://localhost/keiriSysApi/',

// FILE_PATH: 'https://system.syowa.com/files/',
// LOCAL_FILE_PATH: 'http://localhost/files/',

const ConstList = {
  //【メンテ】がついている項目...メンテナンス時に変更する箇所

  //★★★★★★★★★★★★★★★★★
  //★★★不適合管理システム専用★★★
  //★★★★★★★★★★★★★★★★★

  // バージョン
  VERSION: "1.1.1.1",

  //システムトップドメイン
  SYS_TOPDOMAIN: "/", //(AWS)

  //タイトル
  SYS_TITLE: "営業情報管理システム",

  // url【メンテ】
  // REDIRECT_URL: "http://localhost:3000/home", //ローカル
  // DEBUG_LOCAL: true, //ローカル

  REDIRECT_URL: "https://app.mandt-sys.com/home", //本番(AWS)
  DEBUG_LOCAL: false, //本番

  sdmsApi: "https://app.mandt-sys.com/api/", //(AWS)
  LOCAL_sdmsApi: "http://localhost/Sales_Data_Management_System_Api/",

  FILE_PATH: "https://system2.syowa.com/files/",
  LOCAL_FILE_PATH: "http://localhost/files/",

  //★★★★★★★★★★★★★★★★★★★★★★
  //★★★★★★★他システムと共通★★★★★★★
  //★★★★★★★★★★★★★★★★★★★★★★
  DOMAIN: "m-and-t.jp.auth0.com",

  //ユーザー登録に使用する
  CLIENT_ID: "seBYGdY2icx1ri0udumsrXu4dZu65ozw",

  //データベース名
  DATABASE_NAME: "mandt-dev",

  //シークレットトークンを使用したアクセストークン取得用URL
  TOKEN_URL: `https://m-and-t.jp.auth0.com/oauth/token`,

  //M2M認証に使用する
  API_CLIENT_ID: "CYIoJtYhK6n5sYhpGAuaOAOEdX5DSBpW",
  AUDIENCE: "https://m-and-t.jp.auth0.com/api/v2/",
  // 認証用API
  AUTHENTICATION_API: "https://system2.syowa.com/AuthenticationApi/",
  LOCAL_AUTHENTICATION_API: "http://localhost/AuthenticationApi/",

  //URLを切り替える関数
  // nonconformityApiの切り替え
  getApiUrl() {
    if (ConstList.DEBUG_LOCAL) {
      return ConstList.LOCAL_sdmsApi;
    } else {
      return ConstList.sdmsApi;
    }
  },

  //外部APIの切り替え
  getApiType() {
    if (ConstList.DEBUG_LOCAL) {
      return "v1";
      // return 'v1-debug'
    } else {
      return "v1";
    }
  },

  //URLを切り替える関数
  getFileUrl() {
    if (ConstList.DEBUG_LOCAL) {
      return ConstList.LOCAL_FILE_PATH;
    } else {
      return ConstList.FILE_PATH;
    }
  },
  // 認証用APIパス
  getAuthenticationApiUrl() {
    if (ConstList.DEBUG_LOCAL) {
      return ConstList.LOCAL_AUTHENTICATION_API;
    } else {
      // return ConstList.SERVER_API
      return ConstList.AUTHENTICATION_API;
    }
  },

  SLEEP: async (second: number) =>
    new Promise((resolve) => setTimeout(resolve, second)),

  // DataGridPro１ページあたりの行数
  PAGE_SIZE: 30,

  MAX_FILE_SIZE: 50,

  NUM0: 0,
  NUM1: 1,

  // 部署
  HINSYO_DIVISION_ID: 10,

  // ステータス
  PERSON_APPROVAL_PENDING: 1, //承認待ち
  APPROVAL_PENDING: 2, //部門承認待ち
  HINSYO_APPROVAL_PENDING: 3, //品証承認待ち
  CORRECTION_DETAILS_PENDING: 4, //是正内容申請待ち
  CORRECTION_DETAILS_CHECK_PENDING: 5, //是正内容確認待ち
  CORRECTION_DETAILS_APPROVAL_PENDING: 6, //是正内容承認待ち
  FOLLOW_UP: 7, //フォローアップ中
  COMPLETION: 8, //完了
  EDIT_PENDING: 100, //修正待ち
  CORRECTION_DETAILS_EDIT_PENDING: 101, //是正内容修正待ち

  // 権限
  DEVELORER_AUTHORITY: 1, //開発者
  MANAGER_AUTHORITY: 2, //責任者
  NORMAL_AUTHORITY: 3, //一般
  PERSON_AUTHORITY: 4, //品質担当者

  TIME_OUT: 50000,
  AXIOS_CONFIG: {
    headers: {
      // // キャッシュ削除関連
      // 'Cache-Control': 'no-cache, no-store, must-revalidate',
      // Pragma: 'no-cache',
      // Expires: '0',

      // json形式の定義
      "Content-Type": "application/json",
    },
    timeout: 50000,
  },

  // DataGridに使用しているスタイル
  DATA_GRID_STYLES: {
    // 通常用
    grid: {
      // 列ヘッダに背景色を指定
      ".MuiDataGrid-columnHeaders": {
        backgroundColor: "#2f4858",
        color: "#ffffff",
      },
      ".MuiDataGrid-row:not(.MuiDataGrid-row--dynamicHeight)>.MuiDataGrid-cell":
        {
          whiteSpace: "nomal",
          wordWrap: "break-word",
        },
      ".MuiDataGrid-pinnedColumnHeaders": {
        backgroundColor: "#4791db", // ヘッダーの背景色を設定
      },
    },
    // スマホ用
    mobileGrid: {
      // 列ヘッダに背景色を指定
      ".MuiDataGrid-columnHeaders": {
        backgroundColor: "#4791db",
        color: "#fff",
      },
      ".MuiDataGrid-row:not(.MuiDataGrid-row--dynamicHeight)>.MuiDataGrid-cell":
        {
          whiteSpace: "nomal",
          wordWrap: "break-word",
        },
      ".MuiDataGrid-pinnedColumnHeaders": {
        backgroundColor: "#4791db", // ヘッダーの背景色を設定
      },
      fontSize: "0.75rem",
    },
  },

  // アルゴリズム
  ALGORITHM: "RS256",

  // バージョンチェック関数
  async versionCheck() {
    try {
      const response = await axios.get(
        ConstList.getApiUrl() + "getVersion.php",
        ConstList.AXIOS_CONFIG,
      );

      if (response.data != ConstList.VERSION) {
        alert(
          "最新バージョンではありません。OKで再読み込みされます。\n再読み込みしてもアラートが出る場合は、キャッシュを削除してください。",
        );
        {
          !ConstList.DEBUG_LOCAL && window.location.reload();
        }
        return false;
      } else {
        // console.log('最新の状態')

        return true;
      }
    } catch (error) {
      console.log(error);
      alert("エラーが発生しました。\n再読み込みしてください。");
      return false;
    }
  },
};

export default ConstList;
